module.exports = __webpack_public_path__ + "static/media/boost.c4205514.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/boost.svg
// module id = 1089
// module chunks = 21